import React from 'react';
import { TrendingUp, TrendingDown, BellRing, Minus } from 'lucide-react';
import { fmtMoney } from './PocketHome';

const DAY_AR = ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'];

export const PocketInsights = ({ insights, notifState, onEnableNotifs }) => {
  if (!insights) return <div className="pk-view"><div className="pk-empty">جارٍ تحميل التحليلات…</div></div>;
  const d = insights.delta_pct;
  const max = Math.max(...insights.daily.map((x) => x.total), 1);
  return (
    <div className="pk-view" data-testid="pocket-insights-view">
      <div className="pk-topbar">
        <div>
          <div className="pk-greet">Smart insights</div>
          <div className="pk-uname">تحليل أسبوعك</div>
        </div>
      </div>

      <div style={{ padding: '0 20px' }}>
        <div className="pk-card gold" style={{ padding: '18px 18px 20px' }} data-testid="pocket-insights-week-card">
          <div className="pk-card-orb" />
          <div className="pk-scan" />
          <div className="pk-card-tag">صرف آخر ٧ أيام</div>
          <div className="pk-balval" style={{ fontSize: 36 }}><span dir="ltr">{fmtMoney(insights.week_total)}</span></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
            {d == null ? (
              <span className="pk-delta" style={{ color: 'var(--pk-mut)' }}><Minus size={13} /> لا يوجد بيانات كافية للمقارنة</span>
            ) : (
              <span className={`pk-delta ${d >= 0 ? 'up' : 'down'}`}>
                {d >= 0 ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
                <span dir="ltr">{Math.abs(d)}%</span> {d >= 0 ? 'أعلى' : 'أقل'} من متوسطك
              </span>
            )}
            <span style={{ fontSize: 11, color: 'var(--pk-mut)' }} className="pk-num" dir="ltr">4W AVG {fmtMoney(insights.weekly_avg_4w)}</span>
          </div>
          <div className="pk-bars">
            {insights.daily.map((day, i) => (
              <div key={day.date} style={{ flex: 1 }}>
                <div className={`pk-bar ${i === insights.daily.length - 1 ? 'today' : ''}`}
                  style={{ height: `${Math.max((day.total / max) * 64, 3)}px`, animationDelay: `${i * 0.06}s` }} />
                <div className="pk-bar-lbl">{DAY_AR[new Date(day.date + 'T00:00:00').getDay()]}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="pk-sect">أعلى الفئات هذا الأسبوع</div>
      <div style={{ padding: '0 20px' }}>
        {insights.top_categories.length === 0 && <div className="pk-empty">لا مصاريف هذا الأسبوع 🎯</div>}
        {insights.top_categories.map((c, i) => (
          <div key={c.category} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '11px 4px' }}>
            <span className="pk-num" style={{ color: 'var(--pk-gold)', fontSize: 12, width: 22 }} dir="ltr">{String(i + 1).padStart(2, '0')}</span>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13.5, fontWeight: 700 }}>
                <span>{c.category}</span>
                <span className="pk-num" dir="ltr">{fmtMoney(c.total)}</span>
              </div>
              <div style={{ height: 5, borderRadius: 3, background: 'rgba(0,0,0,0.45)', marginTop: 7, overflow: 'hidden' }}>
                <div style={{ height: '100%', borderRadius: 3, width: `${(c.total / (insights.top_categories[0].total || 1)) * 100}%`, background: 'var(--pk-grad)', boxShadow: '0 0 10px rgba(245,158,11,0.4)' }} />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ padding: '20px 20px 0' }}>
        {notifState !== 'granted' && (
          <button className="pk-btn ghost" onClick={onEnableNotifs} data-testid="pocket-enable-notifs" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            <BellRing size={16} style={{ color: 'var(--pk-amber)' }} /> فعّل ملخص الأسبوع كإشعار
          </button>
        )}
        {notifState === 'granted' && (
          <div style={{ fontSize: 12, color: 'var(--pk-mut)', textAlign: 'center' }}>✓ الإشعار الأسبوعي مفعّل — بوصلك ملخص كل أسبوع جديد</div>
        )}
      </div>
    </div>
  );
};
